export default __webpack_public_path__ + "/dist/images/check-icon.c8ba7665cdf59b6746eb0a9410d9d75b.svg";